(function () {
  var root = document.getElementById('valmaGuiaAdvertorial');
  if (!root) return;

  function trackEvent(name, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, data || {}));
    if (window.console && window.console.info) {
      console.info('[valma_guia_padres]', name, data || {});
    }
  }

  trackEvent('advertorial_view', { page: 'guia-para-padres' });

  // scroll depth tracking (25/50/75/100), fired once each
  var scrollMarks = { 25: false, 50: false, 75: false, 100: false };
  var ticking = false;

  function checkScrollDepth() {
    ticking = false;
    var doc = document.documentElement;
    var scrollTop = window.scrollY || doc.scrollTop;
    var scrollHeight = doc.scrollHeight - doc.clientHeight;
    if (scrollHeight <= 0) return;
    var pct = (scrollTop / scrollHeight) * 100;
    [25, 50, 75, 100].forEach(function (mark) {
      if (!scrollMarks[mark] && pct >= mark) {
        scrollMarks[mark] = true;
        trackEvent('advertorial_scroll_' + mark, { page: 'guia-para-padres' });
      }
    });
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(checkScrollDepth);
      ticking = true;
    }
  }, { passive: true });

  // offer section view
  var offerSection = document.getElementById('oferta');
  if (offerSection && 'IntersectionObserver' in window) {
    var offerObserved = false;
    var offerObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !offerObserved) {
          offerObserved = true;
          trackEvent('guia_offer_view', {});
          offerObserver.disconnect();
        }
      });
    }, { threshold: 0.3 });
    offerObserver.observe(offerSection);
  }

  // product CTA clicks (hero, mid-content, offer, final CTA)
  root.querySelectorAll('.guia-cta-product').forEach(function (btn) {
    btn.addEventListener('click', function () {
      trackEvent('guia_product_click', { label: btn.textContent.trim() });
    });
  });

  // sticky mobile CTA — reveal after ~22% scroll, hide near the end
  var stickyCta = document.getElementById('guiaStickyCta');
  var stickyCtaBtn = document.getElementById('guiaStickyCtaBtn');
  if (stickyCta) {
    function checkSticky() {
      var doc = document.documentElement;
      var scrollTop = window.scrollY || doc.scrollTop;
      var scrollHeight = doc.scrollHeight - doc.clientHeight;
      if (scrollHeight <= 0) return;
      var pct = (scrollTop / scrollHeight) * 100;
      stickyCta.classList.toggle('is-visible', pct >= 22 && pct < 96);
    }
    window.addEventListener('scroll', function () {
      window.requestAnimationFrame(checkSticky);
    }, { passive: true });
    checkSticky();
  }
  if (stickyCtaBtn) {
    stickyCtaBtn.addEventListener('click', function () {
      trackEvent('guia_cta_click', { label: 'sticky_ver_oferta' });
    });
  }
})();
